import { api } from './config';

export async function getVirusTotalAnalysis(hash: string, retryCount = 0) {
  const maxRetries = 3;
  const baseDelay = 1000;

  try {
    const response = await api.get(`/api/search/vt/${hash}`);

    if (!response.data) {
      throw new Error('No data received from VirusTotal');
    }

    return response.data;
  } catch (error: any) {
    console.warn(`Attempt ${retryCount + 1} failed:`, error.message);

    if (retryCount < maxRetries) {
      const delay = baseDelay * Math.pow(2, retryCount);
      await new Promise(resolve => setTimeout(resolve, delay));
      return getVirusTotalAnalysis(hash, retryCount + 1);
    }

    let errorMessage = 'Failed to fetch VirusTotal analysis';
    if (error.response?.status === 404) {
      errorMessage = 'File not found in VirusTotal database';
    } else if (error.response?.status === 403) {
      errorMessage = 'Access denied. Please check API key.';
    } else if (error.code === 'ECONNABORTED') {
      errorMessage = 'Request timed out. Please try again.';
    } else if (error.message === 'Network Error') {
      errorMessage = 'Network Error: Could not connect to VirusTotal API. Please try again later.';
    }
    throw new Error(errorMessage);
  }
}